// // LoginModal.jsx
// import React, { useState } from "react";
// import { saveToken } from "./auth";

// const BACKEND_URL = "http://127.0.0.1:8000";

// export default function LoginModal({ onClose, onLoginSuccess }) {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [busy, setBusy] = useState(false);

//   const handleLogin = async () => {
//     if (!username.trim() || !password) {
//       alert("Username and password required.");
//       return;
//     }
//     setBusy(true);
//     try {
//       const res = await fetch(`${BACKEND_URL}/auth/login`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ username, password })
//       });
//       if (!res.ok) {
//         const text = await res.text();
//         alert("Login failed: " + text);
//         setBusy(false);
//         return;
//       }
//       const data = await res.json();
//       saveToken(data.access_token);
//       setBusy(false);
//       if (onLoginSuccess) onLoginSuccess();
//       onClose();
//     } catch (err) {
//       console.error(err);
//       alert("Network error during login.");
//       setBusy(false);
//     }
//   };

//   return (
//     <div style={{
//       position: "fixed",
//       top:0,left:0,right:0,bottom:0, backgroundColor:"rgba(0,0,0,0.5)",
//       display:"flex", alignItems:"center", justifyContent:"center", zIndex:9999
//     }}>
//       <div style={{ background:"#fff", padding:20, width:360, borderRadius:8 }}>
//         <h3>Login</h3>
//         <input placeholder="username" value={username} onChange={(e)=>setUsername(e.target.value)} style={{width:"100%",marginBottom:8}} />
//         <input placeholder="password" value={password} onChange={(e)=>setPassword(e.target.value)} type="password" style={{width:"100%",marginBottom:12}} />
//         <div style={{display:"flex", justifyContent:"flex-end", gap:8}}>
//           <button onClick={onClose} disabled={busy}>Cancel</button>
//           <button onClick={handleLogin} disabled={busy}>
//             {busy ? "Logging..." : "Login"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState } from "react";
import { saveToken } from "./auth";

const BACKEND_URL = "https://staging.parkengage.ai/api";

export default function LoginModal({ onClose, onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const handleLogin = async () => {
    if (!username.trim() || !password) {
      alert("Username and password required.");
      return;
    }
    setBusy(true);
    try {
      const res = await fetch(`${BACKEND_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      if (!res.ok) {
        const text = await res.text();
        alert("Login failed: " + text);
        setBusy(false);
        return;
      }
      const data = await res.json();
      saveToken(data.access_token);
      setBusy(false);
      if (onLoginSuccess) onLoginSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Network error during login.");
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-sm bg-black/20 animate-fadeIn">
      <div className="w-[90%] max-w-sm bg-white/90 backdrop-blur-lg rounded-2xl shadow-2xl p-8 sm:p-10 text-center animate-slideUp">
        <h2 className="text-2xl font-semibold text-indigo-600 mb-2 font-poppins">
          Welcome 👋
        </h2>
        <p className="text-gray-500 text-sm mb-6">
          Please login to continue
        </p>

        <input
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full px-4 py-3 mb-3 border border-gray-300 rounded-lg text-sm outline-none focus:border-indigo-500 transition"
        />
        <input
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          className="w-full px-4 py-3 mb-6 border border-gray-300 rounded-lg text-sm outline-none focus:border-indigo-500 transition"
        />

        <div className="flex gap-3 justify-between">
          <button
            onClick={onClose}
            disabled={busy}
            className="flex-1 py-2.5 rounded-lg bg-gray-200 hover:bg-gray-300 transition font-medium disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleLogin}
            disabled={busy}
            className="flex-1 py-2.5 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition font-semibold disabled:opacity-50"
          >
            {busy ? "Logging in..." : "Login"}
          </button>
        </div>
      </div>

      {/* animations */}
      <style>
        {`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { transform: translateY(40px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-fadeIn { animation: fadeIn 0.3s ease-in-out; }
        .animate-slideUp { animation: slideUp 0.4s ease; }
      `}
      </style>
    </div>
  );
}
